/**
 * Kie.ai Pricing Configuration
 *
 * Kie.ai pricing is significantly cheaper than direct Kling API
 * Prices are in USD per video
 */

/**
 * Kling video pricing via Kie.ai (per video)
 */
export const KIEAI_KLING_PRICING = {
  // Without audio
  "5s": 0.28,
  "10s": 0.55,
  // With audio
  "5s_audio": 0.55,
  "10s_audio": 1.1,
} as const

/**
 * Veo 3 pricing via Kie.ai (per 8s video)
 */
export const KIEAI_VEO_PRICING = {
  veo3_fast: 0.3, // $0.30 per 8s
  veo3: 2.0, // $2.00 per 8s
} as const

/**
 * Calculate the cost of a Kling video via Kie.ai
 *
 * @param duration - Video duration in seconds (5 or 10)
 * @param hasAudio - Whether the video includes audio
 * @returns Cost in USD
 */
export function calculateKieAIKlingCost(duration: 5 | 10, hasAudio: boolean): number {
  if (duration === 5) {
    return hasAudio ? KIEAI_KLING_PRICING["5s_audio"] : KIEAI_KLING_PRICING["5s"]
  }
  return hasAudio ? KIEAI_KLING_PRICING["10s_audio"] : KIEAI_KLING_PRICING["10s"]
}
